import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=0f764a12&scoped=true&"
import script from "./ProductsTable.vue?vue&type=script&lang=ts&"
export * from "./ProductsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f764a12",
  null
  
)

export default component.exports